import React, { Component } from 'react'
import { TableRow, TableCell } from '@material-ui/core'

// utils
import { onChangeEditHOF } from '../../utils/common'
import { hasAccess } from '../../utils/api'

import { EditableTextField, EditableSwitch } from '../common/EditableComponents'
import EditActionComponent from '../common/EditActionComponent'

export default class TaxDisplayNameItem extends Component {
  onChange = onChangeEditHOF(this.props.onChange)

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  render() {
    const { data = {}, editMode = false, companyFeatures = {} } = this.props

    return (
      <TableRow>
        <TableCell>{data.taxTerritory || ''}</TableCell>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.name || ''}
            editMode={editMode}
            value={data.name}
            onChange={this.onChange('name')}
            type="text"
          />
        </TableCell>
        {companyFeatures.enableAppendTax ? (
          <TableCell className="cell-wrap-word">
            <EditableSwitch
              valueToRender={data.appendTax ? 'Enabled' : 'Disabled'}
              checked={data.appendTax}
              editMode={editMode}
              onChange={this.onChange('appendTax', true)}
            />
          </TableCell>
        ) : null}
        <TableCell className="cell-wrap-word">
          {hasAccess() ? (
            <div>
              <EditActionComponent
                onSave={this.onSave}
                onCancel={this.onCancel}
                onEdit={this.props.enableEdit}
                editMode={editMode}
              />
            </div>
          ) : null}
        </TableCell>
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/TaxOption/TaxDisplayNameItem.js